














import { Component, Watch, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import MainNavBar from '@/shared/components/MainNavBar.component.vue';

@Component({
  computed: {
    ...mapGetters({
      scrollTop: 'scrollTop',
      mainNavbarIsOpen: 'isOpenNavbar',
    }),
  },
  components: {
    MainNavBar,
  },
})
export default class ManagerLayout extends Vue {
  private mainNavbarIsOpen!: boolean;

  @Watch('scrollTop')
  private watchScrollTop(newVal: number, oldVal: number) {
    (this.$refs.mainContainer as HTMLElement).scrollTop = newVal;
  }

  private handleScroll(event: any) {
    const scrollTop = (this.$refs.mainContainer as HTMLElement).scrollTop;
    this.$store.dispatch('setScrollTop', scrollTop);
  }
}
